module.exports = __webpack_public_path__ + "img/alexsToolbox.0ee54e54.webp";